import {
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USERS_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  GET_ROLES_REQUEST,
  GET_ROLES_SUCCESS,
  GET_ROLES_FAILURE,
  CREATE_ROLE_REQUEST,
  CREATE_ROLE_SUCCESS,
  CREATE_ROLE_FAILURE,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAILURE,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAILURE,
  GET_ROLE_PERMISSIONS_REQUEST,
  GET_ROLE_PERMISSIONS_SUCCESS,
  GET_ROLE_PERMISSIONS_FAILURE,
  UPDATE_ROLE_PERMISSIONS_REQUEST,
  UPDATE_ROLE_PERMISSIONS_SUCCESS,
  UPDATE_ROLE_PERMISSIONS_FAILURE,
  GET_AVAILABLE_MODULES_REQUEST,
  GET_AVAILABLE_MODULES_SUCCESS,
  GET_AVAILABLE_MODULES_FAILURE,
} from '../types';

// Separate initial states for different slices
const usersInitialState = {
  users: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
  loading: false,
  error: null,
};

const rolesInitialState = {
  roles: [],
  loading: false,
  error: null,
};

const permissionsInitialState = {
  permissions: [],
  loading: false,
  error: null,
};

const modulesInitialState = {
  modules: { modules: [] },
  loading: false,
  error: null,
};

// Users Reducer
export const usersReducer = (state = usersInitialState, action) => {
  switch (action.type) {
    case GET_USERS_REQUEST:
    case CREATE_USER_REQUEST:
    case UPDATE_USER_REQUEST:
    case DELETE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.users || [],
        pagination: action.payload.pagination || state.pagination,
        loading: false,
        error: null,
      };

    case CREATE_USER_SUCCESS:
      return {
        ...state,
        users: [action.payload, ...state.users],
        loading: false,
        error: null,
      };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map(user =>
          user.id === action.payload.id ? action.payload : user
        ),
        loading: false,
        error: null,
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.filter(user => user.id !== action.payload),
        loading: false,
        error: null,
      };

    case GET_USERS_FAILURE:
    case CREATE_USER_FAILURE:
    case UPDATE_USER_FAILURE:
    case DELETE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

// Roles Reducer
export const rolesReducer = (state = rolesInitialState, action) => {
  switch (action.type) {
    case GET_ROLES_REQUEST:
    case CREATE_ROLE_REQUEST:
    case UPDATE_ROLE_REQUEST:
    case DELETE_ROLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload || [],
        loading: false,
        error: null,
      };

    case CREATE_ROLE_SUCCESS:
      return {
        ...state,
        roles: [...state.roles, action.payload],
        loading: false,
        error: null,
      };

    case UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        roles: state.roles.map(role =>
          role.id === action.payload.id ? action.payload : role
        ),
        loading: false,
        error: null,
      };

    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        roles: state.roles.filter(role => role.id !== action.payload),
        loading: false,
        error: null,
      };

    case GET_ROLES_FAILURE:
    case CREATE_ROLE_FAILURE:
    case UPDATE_ROLE_FAILURE:
    case DELETE_ROLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

// Permissions Reducer
export const rolePermissionsReducer = (state = permissionsInitialState, action) => {
  switch (action.type) {
    case GET_ROLE_PERMISSIONS_REQUEST:
    case UPDATE_ROLE_PERMISSIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_ROLE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: action.payload || [],
        loading: false,
        error: null,
      };

    case UPDATE_ROLE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: action.payload || [],
        loading: false,
        error: null,
      };

    case GET_ROLE_PERMISSIONS_FAILURE:
    case UPDATE_ROLE_PERMISSIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

// Available Modules Reducer
export const availableModulesReducer = (state = modulesInitialState, action) => {
  switch (action.type) {
    case GET_AVAILABLE_MODULES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_AVAILABLE_MODULES_SUCCESS:
      return {
        ...state,
        modules: action.payload || { modules: [] },
        loading: false,
        error: null,
      };

    case GET_AVAILABLE_MODULES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
